
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/solar-generators",
      function () {
        return require("private-next-pages/collections/solar-generators/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/solar-generators"])
      });
    }
  